import { Component, Input, OnInit } from '@angular/core'
import { LoginService } from '../login/login.service'
import { BuilderService } from '../builder-services/builder.service'
import { BackupService } from '../builder-services/backup.service'
import { finalize } from 'rxjs/operators'

@Component({
  selector: 'app-backup',
  standalone: false,
  templateUrl: './backup.component.html',
  styleUrl: './backup.component.scss'
})
export class BackupComponent {
  /**
   * The node that should be restored
   *
   * This value is passed from the parent component, so each <app-backup> instance can handle
   * a different part of the project independently.
   *
   * Example:
   *   <app-backup backupNode="products"></app-backup>
   */
  @Input('backupNode') backupNode: string = ''

  //Currently selected project ID, stored in local storage
  projectId = localStorage.getItem('selectedProject')

  //List of backup file names fetched
  backups: string[] = []

  /**
   * Index of the currently selected backup file.
   * Defaults to 0 (the most recent backup).
   */
  selectedBackup: number = 0
  errorMessage: string = ''

  constructor(private loginService: LoginService, private builderService: BuilderService, private backupService: BackupService) {}

  /**
   * Fetches all available backups
   *
   * - Call the BackupService.getBackups() method,
   *    passing the projectId as a parameter to the API.
   *
   * - Subscribe to the observable:
   *    - On success (`next`): store the returned backups in the local `backups` array
   *      so they can be displayed in the dropdown list
   */
  getBackups(): void {
    if (this.projectId && this.isAdmin) {
      this.backupService.getBackups(this.projectId).subscribe({
        next: (backups) => {
          this.backups = backups as string[] // Update local array with the backup list
        },
        error: (error) => {
          this.errorMessage = error.error || error.message
        }
      })
    }
  }

  /**
   * Restore the selected node of the project using a backup file.
   *
   * - The "node" parameter tells which section of the project to restore.
   * - The "selectedBackup" parameter chooses which backup file (by index) to restore.
   * - While the restore is in progress, the UI shows a loading state via showUpdateProgress.
   * - finalize() ensures that the loading state is turned off whether success or failure.
   */
  onRestore() {
    this.builderService.showUpdateProgress = true
    if (this.projectId && this.isAdmin) {
      this.backupService
        .backupNode(this.projectId, this.backupNode, this.selectedBackup)
        .pipe(finalize(() => (this.builderService.showUpdateProgress = false)))
        .subscribe(
          (response) => console.log('Restore success:', response),
          (error) => (this.errorMessage = error.error || error.message)
        )
    }
  }

  get isAdmin(): boolean {
    return this.loginService.getCurrentUser().admin
  }
}
